import { Menu, Transition } from '@headlessui/react'
import Translation from 'components/Translation'
import { useAuth } from 'context/AuthContext'
import { Fragment } from 'react'
import logout from 'services/cognito/logout'
import { classNames } from 'utils/dom-helpers'
import { useTenantContext } from '../../../../context/TenantContext'
import { default_border_color, default_primary_color } from '../../../../context/AuthContext'

export function ClientUserDropdown() {
    const { user, user_profile } = useAuth()
    const { primaryColor, tenant } = useTenantContext()

    async function killSession() {
        try {
            await logout()
            location.href = `/book/?t=${tenant?.id}`
        } catch (e) {
            console.error(e)
        }
    }

    return user?.first_name ? (
        <Menu as="div" className="relative">
            <Menu.Button className="bg-gray-100 items-center w-10 h-10 text-center justify-center p-1 flex v-center border-2 text-md font-bold rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-800 focus:ring-white"
                style={{
                    borderColor: primaryColor ? primaryColor : default_border_color,
                    color: primaryColor ? primaryColor : default_primary_color
                }}
            >
                <span className="sr-only"><Translation content_key="booking.open_user_menu" /></span>
                {user_profile?.user &&
                user_profile?.user.imageUrl?.length ? (
                    <img
                        className="w-8 h-8 rounded-full max-w-none"
                        src={user_profile?.user.imageUrl}
                        alt="profile"
                    />
                ) : (
                    user?.first_name[0] + user?.last_name[0]
                )}
            </Menu.Button>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="z-20 w-48 origin-top-right absolute right-0 mt-2 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <Menu.Item>
                        {({ active }) => (
                            <a
                                href={`/book/client/appointments`}
                                className={classNames(
                                    active ? 'bg-gray-200' : '',
                                    'block px-4 py-2 text-sm text-black'
                                )}
                            >
                                <i className="feather-calendar text-lg align-middle text-gray-500 p-1 mr-2" />
                                <Translation
                                    render_as="span"
                                    className="align-middle"
                                    content_key="booking_page.appointments"
                                />
                            </a>
                        )}
                    </Menu.Item>
                    <Menu.Item>
                        {({ active }) => (
                            <a
                                href={`/book/client/profile/`}
                                className={classNames(
                                    active ? 'bg-gray-200' : '',
                                    'block px-4 py-2 text-sm text-black'
                                )}
                            >
                                <i className="feather-user text-lg align-middle rounded-full text-gray-500 border border-gray-500 p-1 mr-2" />
                                <Translation
                                    render_as="span"
                                    className="align-middle"
                                    content_key="booking.account"
                                />
                            </a>
                        )}
                    </Menu.Item>
                    <Menu.Item>
                        {({ active }) => (
                            <button
                                onClick={killSession}
                                className={classNames(
                                    active ? 'bg-gray-200' : '',
                                    'w-full text-left block px-4 py-2 text-sm text-black'
                                )}
                            >
                                <i className="feather-log-out text-lg align-middle text-gray-500 p-1 mr-2" />
                                <Translation
                                    render_as="span"
                                    className="align-middle"
                                    content_key="booking.sign_out"
                                />
                            </button>
                        )}
                    </Menu.Item>
                </Menu.Items>
            </Transition>
        </Menu>
    ) : (
        <>
        </>
    )
}

export default ClientUserDropdown
